import {useLocation, useNavigate} from 'react-router-dom';
import {SoopSectionTitle} from '@soop-ui/soop-ui';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {useGetFaqList, useGetFaqListInfinity} from '@/hooks/help';
import FaqBoard from '@/components/help/common/FaqBoard';
import {FAQ_MAIN_CATEGORY} from '@/constants/help/faq';
import styles from './Faq.module.scss';

const DEFAULT_MAIN_CATEGORY = FAQ_MAIN_CATEGORY[0].key;

const HelpFaq = () => {
  const {isMobile} = useHelpContext();
  const {state} = useLocation();
  const subCategory = state?.subCategory || '';
  const mainCategory = state?.mainCategory || DEFAULT_MAIN_CATEGORY;
  const navigate = useNavigate();

  const pcResult = useGetFaqList({
    category: subCategory || mainCategory,
    page: state?.page || 1,
  });
  const mobileResult = useGetFaqListInfinity({
    category: subCategory || mainCategory,
  });

  return (
    <>
      {!isMobile && (pcResult.data?.faqList?.length || 0) > 0 && (
        <SoopSectionTitle className={styles.SectionTitle}>
          <SoopSectionTitle.Title size='lg'>Q&A</SoopSectionTitle.Title>
        </SoopSectionTitle>
      )}
      <FaqBoard
        type='faq'
        {...(isMobile
          ? mobileResult
          : {
              ...pcResult,
              onPageChange: (page: number) =>
                navigate('', {
                  state: {mainCategory, subCategory, page},
                }),
            })}
      />
    </>
  );
};

export default HelpFaq;
